import Nav from "./nav"
import HomeSlider from "./home-slider"
import IngredientsSlider from "./ingredients-slider"
import SubmitReviewLink from "./submit-review-link"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    HomeSlider(jQuery)
    IngredientsSlider(jQuery)
    SubmitReviewLink(jQuery)
})
